import { useAuth0 } from '@auth0/auth0-react'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { PolicyId } from '@estercare/ester-shared'
import { acknowledgePolicy, declinePolicy } from './policies'

type AcknowledgePolicyVariables = { policyId: PolicyId; version: string; language: string }

export const useAcknowledgePolicyMutation = (
  options?: UseMutationOptions<Response, Error, AcknowledgePolicyVariables>
) => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationFn: async ({ policyId, version, language }: AcknowledgePolicyVariables) => {
      const accessToken = await getAccessTokenSilently()
      return await acknowledgePolicy({ accessToken, policyId, version, language })
    },
    ...options,
  })
}

export const useDeclinePolicyMutation = (options?: UseMutationOptions<Response, Error, PolicyId>) => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationFn: async (policyId: PolicyId) => {
      const accessToken = await getAccessTokenSilently()
      return await declinePolicy({ accessToken, policyId })
    },
    ...options,
  })
}
